import React, { useState, useEffect } from 'react';
import { FaCheck, FaClock } from 'react-icons/fa';
import {
  AdminContentContainer,
  AdminContentTitle,
  AdminContentForm,
  FormGroup,
  AdminContentLabel,
  AdminContentInput,
  DropdownContainer,
  AdminContentSearchInput,
  AdminContentDropdownList,
  AdminContentDropdownItem,
  AdminContentNoResults,
  AdminContentButton,
  AdminContentCouponList,
  AdminContentCouponItem,
  CouponDetails,
  DeleteButton,
  ErrorContainer,
  ErrorText,
} from '../styles';
import { Spinner, Collapsible } from ".";
import { adminGetCoupons, adminCreateCoupon, adminDeleteCoupon } from '../api';

const CouponGenerator = ({ allUsers }) => {
  const [coupons, setCoupons] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    name: '',
    discount: '',
    expiryDate: '',
    users: [],
    type: 'fixed',
  });
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const setUser = () => {

      const allUsersCombined = [
        ...allUsers.admin.users, // Usuários admin
        ...allUsers.professor.users, // Usuários professor
        ...allUsers.worker.users, // Usuários trabalhador
        ...allUsers.user.users, // Usuários comuns
      ];

      setUsers(allUsersCombined);
    };

    setUser();
  }, [allUsers.admin.users, allUsers.professor.users, allUsers.worker.users, allUsers.user.users]);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {

        const response = await adminGetCoupons();

        const data = await response.json();

        setCoupons(data);

      } catch (error) {
        setError('Erro ao buscar cupons: ' + error.message);
        console.error('Erro ao buscar cupons:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, []);

  const reloadCoupons = async () => {
    try {

      setLoading(true);

      const response = await adminGetCoupons();

      const data = await response.json();

      setCoupons(data);

    } catch (error) {
      setError('Erro ao buscar cupons: ' + error.message);
      console.error('Erro ao buscar cupons:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.nome.toLowerCase().includes(search.toLowerCase())
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.discount || !form.expiryDate || form.users.length === 0) {
      alert('Preencha todos os campos!');
      return;
    }

    try {

      const requestData = {
        code: form.name,
        type: form.type, // Aqui vai o tipo de desconto (fixed ou percentage)
        discount: parseFloat(form.discount),
        expiration: form.expiryDate,
        users: form.users.map(user => user.username), // Aqui estamos pegando somente os usernames
      };

      const response = await adminCreateCoupon(requestData);

      const data = await response.json();

      if (data.error) {
        setError(data.error);
      } else {
        console.log('Cupom criado com sucesso:', data);
        setSearch('');
        setForm({ name: '', discount: '', expiryDate: '', users: [], type: 'fixed' });
        reloadCoupons();
      }

    } catch (error) {
      setError('Erro ao buscar cupons: ' + error.message);
      console.error('Erro ao buscar cupons:', error);
    }
  };

  const removeUser = (username) => {
    setForm((prev) => ({
      ...prev,
      users: prev.users.filter((user) => user.username !== username),
    }));
  };

  const removeCoupon = async (couponId) => {

    try {

      const response = await adminDeleteCoupon(couponId);

      if (response.ok) {
        reloadCoupons();
      }

    } catch (error) {
      setError('Erro ao buscar cupons: ' + error.message);
      console.error('Erro ao buscar cupons:', error);
    }
  };

  function formatDate(date) {
    const dateParts = date.split('-'); // Divide a data no formato aaaa-mm-dd
    if (dateParts.length !== 3) return ''; // Verifica se a data tem o formato correto (3 partes)
    const [year, month, day] = dateParts; // Desestrutura os componentes da data
    return `${day}/${month}/${year}`; // Retorna a data no formato dd/mm/aaaa
  }

  const CouponStatusIcon = ({ isUsed }) => (
    <span
      title={isUsed ? 'Cupom utilizado' : 'Cupom disponível'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 6,
        color: isUsed ? '#16a34a' : '#eab308',
      }}
    >
      {isUsed ? <FaCheck size={25} /> : <FaClock size={25} />}
    </span>
  );

  if (loading) {
    return <Spinner />;
  }

  return (
    <AdminContentContainer>
      <AdminContentTitle>Gerar Cupons de Desconto</AdminContentTitle>

      {/* Formulário */}
      <AdminContentForm onSubmit={handleSubmit}>
        <FormGroup>
          <AdminContentLabel>Nome do Cupom</AdminContentLabel>
          <AdminContentInput
            type="text"
            name="name"
            placeholder="Ex: DESCONTO10"
            value={form.name}
            onChange={handleInputChange}
          />
        </FormGroup>
        <FormGroup>
          <AdminContentLabel>Tipo de Desconto</AdminContentLabel>
          <select
            style={{ padding: "8px 0 8px 4px"}}
            name="type"
            value={form.type}
            onChange={handleInputChange}
          >
            <option value="fixed">Fixo em reais (R$)</option>
            <option value="percentage">Percentual de Desconto (%)</option>
          </select>
        </FormGroup>
        <FormGroup>
          <AdminContentLabel>Desconto (R$)</AdminContentLabel>
          <AdminContentInput
            type="number"
            name="discount"
            placeholder="Ex: 10"
            value={form.discount}
            onChange={handleInputChange}
          />
        </FormGroup>
        <FormGroup>
          <AdminContentLabel>Data de Validade</AdminContentLabel>
          <AdminContentInput
            type="date"
            name="expiryDate"
            value={form.expiryDate}
            onChange={handleInputChange}
          />
        </FormGroup>
        <FormGroup>
          <AdminContentLabel>Vincular a Usuário(s)</AdminContentLabel>
          <DropdownContainer>
            <AdminContentSearchInput
              type="text"
              placeholder="Buscar usuário"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <AdminContentDropdownList>
                {filteredUsers.map((user) => (
                  <AdminContentDropdownItem
                    key={user.username}
                    onClick={() => {
                      setForm((prev) => ({ ...prev, users: [...prev.users, user] }));
                      setSearch('');
                    }}
                  >
                    {user.nome} ({user.username})
                  </AdminContentDropdownItem>
                ))}
                {filteredUsers.length === 0 && (
                  <AdminContentNoResults>Nenhum usuário encontrado</AdminContentNoResults>
                )}
              </AdminContentDropdownList>
            )}
          </DropdownContainer>
        </FormGroup>
        {form.users.length > 0 && (
          <div>
            <h4>Usuários Vinculados:</h4>
            <ul>
              {form.users.map((user, index) => (
                <li style={{marginBottom: "10px"}} key={index}>
                  {user.nome} ({user.username})
                  <button onClick={() => removeUser(user.username)} style={{marginLeft: "5px"}}>Remover</button>
                </li>
              ))}
            </ul>
          </div>
        )}
        <AdminContentButton type="submit">Gerar Cupom</AdminContentButton>
      </AdminContentForm>

      {/* Lista de Cupons Gerados */}
      <AdminContentCouponList>
        <h2 style={{ fontFamily: "Bellota", color: "#254671", textAlign: "center", marginTop: "40px" }}>
          Cupons Criados
        </h2>
        <p style={{textAlign: 'center'}}>Total: {coupons.summary.total} Usados: {coupons.summary.used} Disponíveis: {coupons.summary.unused} Expirados: {coupons.summary.expired}</p>

        <Collapsible title="Cupons Criados pelo Admin:">
          {coupons.admin && coupons.admin.length > 0 ? (
            <ul>
              {coupons.admin.map((coupon) => (
                <AdminContentCouponItem key={coupon.id}>
                  <CouponDetails>
                    <CouponStatusIcon isUsed={coupon.is_used} /> <br /> <br />
                    <strong>Nome do Cupom:</strong> {coupon.coupon_code} <br />
                    <strong>Desconto: </strong> 
                    {coupon.type === 'fixed' 
                      ? `R$${parseFloat(coupon.value).toFixed(2)}` 
                      : `${parseFloat(coupon.value) % 1 === 0 ? parseFloat(coupon.value) : parseFloat(coupon.value).toFixed(2)}%`} <br />
                    <strong>Data de Expiração:</strong> {formatDate(coupon.expiration)} <br />
                    <strong>Usuários Vinculados:</strong> {coupon.users.join(', ')} <br />
                    {coupon.is_used && <><strong>Utilizado em:</strong> {coupon.used_at} <br /></>}
                  </CouponDetails>
                  <DeleteButton onClick={() => removeCoupon(coupon.id)}>Excluir</DeleteButton>
                </AdminContentCouponItem>
              ))}
            </ul>
          ) : (
            <p>Nenhum cupom criado pelo Admin.</p>
          )}
        </Collapsible>

        <Collapsible title="Cupons Criados pelo Sistema:">
          {coupons.system && coupons.system.length > 0 ? (
            <ul>
              {coupons.system.map((coupon) => (
                <AdminContentCouponItem key={coupon.id}>
                  <CouponDetails>
                    <CouponStatusIcon isUsed={coupon.is_used} /> <br /> <br />
                    <strong>Nome do Cupom:</strong> {coupon.coupon_code} <br />
                    <strong>Desconto:</strong> 
                    {coupon.type === 'fixed' ? `R$${coupon.value}` : `${coupon.value % 1 === 0 ? coupon.value : coupon.value.toFixed(2)}%`} <br />
                    <strong>Data de Expiração:</strong> {formatDate(coupon.expiration)} <br />
                    <strong>Usuários Vinculados:</strong> {coupon.users.join(', ')} <br />
                    {coupon.is_used && <><strong>Utilizado em:</strong> {coupon.used_at} <br /></>}
                  </CouponDetails>
                  <DeleteButton onClick={() => removeCoupon(coupon.id)}>Excluir</DeleteButton>
                </AdminContentCouponItem>
              ))}
            </ul>
          ) : (
            <p>Nenhum cupom criado pelo Sistema.</p>
          )}
        </Collapsible>

        <Collapsible title="Cupons Expirados:">
          {coupons.expired && coupons.expired.length > 0 ? (
            <ul>
              {coupons.expired.map((coupon) => (
                <AdminContentCouponItem key={coupon.id}>
                  <CouponDetails>
                    <CouponStatusIcon isUsed={coupon.is_used} /> <br /> <br />
                    <strong>Nome do Cupom:</strong> {coupon.coupon_code} <br />
                    <strong>Desconto:</strong> 
                    {coupon.type === 'fixed' ? `R$${coupon.value}` : `${coupon.value % 1 === 0 ? coupon.value : coupon.value.toFixed(2)}%`} <br />
                    <strong>Data de Expiração:</strong> {formatDate(coupon.expiration)} <br />
                    <strong>Usuários Vinculados:</strong> {coupon.users.join(', ')} <br />
                    {coupon.is_used && <><strong>Utilizado em:</strong> {coupon.used_at} <br /></>}
                  </CouponDetails>
                </AdminContentCouponItem>
              ))}
            </ul>
          ) : (
            <p>Nenhum cupom expirado.</p>
          )}
        </Collapsible>
      </AdminContentCouponList>

      {/* Exibição de erro */}
      {error && (
        <ErrorContainer>
          <ErrorText style={{ color: 'red' }}>{error}</ErrorText>
        </ErrorContainer>
      )}
    </AdminContentContainer>
  );
};

export default CouponGenerator;
